
import dayjs from "dayjs";
import {
  canCancelLessonRequest,
  getRequestTypeMeta,
  formatLessonRequestDayOrder,
  LESSON_REQUEST_STATUS_TONE,
  LESSON_REQUEST_STATUS_LABEL
} from "constants/lessonRequest";

import Badge from "../common/Badge";
import OpenedReservationLinks from "./OpenedReservationLinks";

const formatTime = (value) => (value ? String(value).slice(0, 5) : "");

const getCardTitle = (request, meta) => {
  if (request?.request_type === "SPECIAL" && request?.topic) return request.topic;
  return request.request_type_display || meta.title;
};

const getCardSubtitle = (request, meta) => {
  if (request?.request_type === "SPECIAL" && request?.topic) {
      return request.request_type_display || meta.title;
  }
  return request.lesson_product_name || request.sport_name || "수업 요청";
};

const getTopicLabel = (request) => {
  if (request?.request_type === "PREMIUM") return "요청 메모";
  if (request?.request_type === "SPECIAL") return "스페셜 제목";
  return "주제";
};


function LessonRequestCard({ request, onCancel, onOpen }) {
  const meta = getRequestTypeMeta(request.request_type);
  const scheduleLabel = [
      request.requested_date ? dayjs(request.requested_date).format("YYYY.MM.DD") : "날짜 미정",
      `${formatTime(request.requested_start_time)}-${formatTime(request.requested_end_time)}`,
  ].filter(Boolean).join(" · ");
  const dayOrderLabel = formatLessonRequestDayOrder(request);

  return (
      <article
          className="lesson-request-list-card lesson-request-list-card--clickable"
          role="button"
          tabIndex={0}
          onClick={() => onOpen(request.id)}
          onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onOpen(request.id);
              }
          }}
      >
          <div className="lesson-request-list-card__top">
              <div>
                  <strong>{getCardTitle(request, meta)}</strong>
                  <small>{getCardSubtitle(request, meta)}</small>
              </div>
              <Badge 
                  text={request?.status_display || LESSON_REQUEST_STATUS_LABEL[request?.status] || request?.status || "상태 미정"} 
                  type="soft" 
                  color={LESSON_REQUEST_STATUS_TONE[request?.status]}/>
          </div>
          <dl>
              <div>
                  <dt>일정</dt>
                  <dd>{scheduleLabel}</dd>
              </div>
              <div>
                  <dt>장소</dt>
                  <dd>{request.location_name || "장소 미정"}</dd>
              </div>
              {dayOrderLabel && (
                  <div>
                      <dt>회차</dt>
                      <dd>{dayOrderLabel}</dd>
                  </div>
              )}
              {request.topic && request.request_type !== "SPECIAL" && (
                  <div>
                      <dt>{getTopicLabel(request)}</dt>
                      <dd>{request.topic}</dd>
                  </div>
              )}
              <div>
                  <dt>강사</dt>
                  <dd>{request.candidate_count ?? 0}명</dd>
              </div>
              {request.requester_message &&<div>
                  <dt>요청사항</dt>
                  <dd>{request.requester_message}</dd>
              </div>}
          </dl>

          <OpenedReservationLinks request={request} />

          <footer>
              <span>{request.created_at ? dayjs(request.created_at).format("YYYY.MM.DD HH:mm") : ""}</span>
              {canCancelLessonRequest(request) && (
                  <button
                      type="button"
                      onClick={(event) => {
                          event.stopPropagation();
                          onCancel(request.id);
                      }}
                  >
                      요청 취소
                  </button>
              )}
          </footer>
      </article>
  );
}

export default LessonRequestCard;